import axios from 'axios';

const api = axios.create({
    baseURL: '/master-plan-api',
    headers: {
        'Content-Type': 'application/json'
    },
});

export { api };